import { useEffect, useState } from "react";
import { supabase } from "@/integrations/supabase/client";

export interface QaCapabilities {
  loading: boolean;
  enabled: boolean;
}

export function useQaCapabilities(): QaCapabilities {
  const [state, setState] = useState<QaCapabilities>({ loading: true, enabled: false });

  useEffect(() => {
    let cancelled = false;
    (async () => {
      const { data, error } = await (supabase.rpc as any)("get_my_qa_capabilities");
      if (cancelled) return;
      if (error) {
        setState({ loading: false, enabled: false });
        return;
      }
      setState({ loading: false, enabled: Boolean(data?.enabled) });
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  return state;
}
